import { render, staticRenderFns } from "./EventExtension.vue?vue&type=template&id=cf312a08&"
import script from "./EventExtension.vue?vue&type=script&lang=ts&"
export * from "./EventExtension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports